<template>
  <div>
    <v-toolbar color="#FEF3C8" class="elevation-0" dense>
      <v-text-field
        prepend-icon="mdi-account-circle"
        type="text"
        v-model="search"
        label="Nom d'un contact"
      >
      </v-text-field>
    </v-toolbar>

    <v-list two-line>
      <v-list-item-group v-model="selected" active-class="pink--text">
        <template v-for="contact in liste">
          <v-list-item
            :key="contact.Cont_ID"
            @click="SelectedCont(contact)"
            class="bottoml"
          >
            <template>
              <v-list-item-content>
                <v-list-item-title v-html="contact.Nom"> </v-list-item-title>
                <v-list-item-subtitle v-html="contact.addres">
                </v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  contact.subtitle
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <v-list two-line>
      <v-list-item-group active-class="pink--text">
        <template>
          <v-list-item class="bottoml">
            <template>
              <v-list-item-content>
                <v-list-item-title></v-list-item-title>
                <v-list-item-subtitle></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>

    <!--################    MODALE DOSSIER CLIENT ################################### -->
    <v-dialog
      v-model="showModalDoss"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#FEF3C8">
          <v-btn icon dark @click="showModalDoss = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >{{ chosenOne.Cont_Civ }} {{ chosenOne.Cont_Nom }}
            {{ chosenOne.Cont_Pren }} {{ chosenOne.html }}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-toolbar-items v-if="ClickOK == 1">
            <v-btn value="main" :to="{ name: 'MainPage' }">
              <v-icon>mdi-camera</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn value="cal" :to="{ name: 'Calendrier' }" class="calend">
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list dense>
          <v-subheader v-if="ClickOK == 1">
            <v-select
              v-model="chosenEtat"
              :items="etats"
              item-text="Et_Nom"
              item-value="Et_ID"
              @change="UpdEtat"
            ></v-select>
          </v-subheader>
          <v-list-item-group
            v-model="selectedItem"
            color="primary"
            class="liste"
          >
            <v-list-item>
              <v-list-item-content>
                <h1>{{ chosenOne.Cont_Nouvnom }}</h1>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account-card-details</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a
                  target="_blank"
                  :href="
                    'https://waze.com/ul?q=' +
                      chosenOne.Cont_Rue +
                      ', ' +
                      chosenOne.Cont_Postal +
                      ' ' +
                      chosenOne.Cont_Ville +
                      '&navigate=yes'
                  "
                  >{{ chosenOne.Cont_Rue }} {{ chosenOne.Cont_Postal }}
                  {{ chosenOne.Cont_Ville }}</a
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-phone-classic</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a @click="handleAppelClick(chosenOne.Cont_TelFix)">{{
                  chosenOne.Cont_TelFix
                }}</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-cellphone-iphone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a @click="handleAppelClick(chosenOne.Cont_TelMob)">{{
                  chosenOne.Cont_TelMob
                }}</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="chosenOne.Cont_TelMobmob">
              <v-list-item-icon>
                <v-icon>mdi-cellphone-iphone</v-icon> 2
              </v-list-item-icon>
              <v-list-item-content>
                <a @click="handleAppelClick(chosenOne.Cont_TelMobmob)">{{
                  chosenOne.Cont_TelMobmob
                }}</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="chosenOne.Cont_TelMobtwo">
              <v-list-item-icon>
                <v-icon>mdi-cellphone-iphone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a @click="handleAppelClick(chosenOne.Cont_TelMobtwo)">{{
                  chosenOne.Cont_TelMobtwo
                }}</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a :href="`mailto:${chosenOne.Cont_Email}`">{{
                  chosenOne.Cont_Email
                }}</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="chosenOne.Cont_Emailtwo">
              <v-list-item-icon>
                <v-icon>mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a :href="`mailto:${chosenOne.Cont_Emailtwo}`">{{
                  chosenOne.Cont_Emailtwo
                }}</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-application</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ chosenOne.Cont_Comment }}
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-subheader class="sections">Rendez-vous</v-subheader>
        <v-list two-line>
          <v-list-item-group v-model="listrdv" active-class="pink--text">
            <template v-for="rdv in rdvs">
              <v-list-item :key="rdv.Pres_ID" class="bottoml">
                <template>
                  <v-list-item-content>
                    <v-list-item-title> {{ rdv.html }}</v-list-item-title>
                    <v-list-item-subtitle>{{ rdv.deb }} </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

        <v-layout align-center justify-space-between>
          <v-subheader class="sections">Notes</v-subheader>
          <v-btn small color="primary" @click="ajoutNote()"
            >Ajouter une note</v-btn
          >
        </v-layout>
        <v-list two-line>
          <v-list-item-group active-class="pink--text">
            <template v-for="note in notes">
              <v-list-item
                :key="note.N_ID"
                class="bottoml"
                @click="EditNote(note.N_ID, note.N_Desc)"
              >
                <template>
                  <v-list-item-content>
                    <v-list-item-title v-html="note.html"></v-list-item-title>
                    <v-list-item-subtitle
                      >{{ note.stitre }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

        <v-subheader class="sections">Affaires</v-subheader>
        <v-list two-line>
          <v-list-item-group active-class="pink--text">
            <template v-for="affaire in affaires">
              <v-list-item :key="affaire.Fp_ID" class="bottoml">
                <template>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="affaire.html"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      >{{ affaire.pdt }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

        <v-subheader class="sections">fiches SAV</v-subheader>
        <v-list two-line>
          <v-list-item-group active-class="pink--text">
            <template v-for="sav in savs">
              <v-list-item :key="sav.Fp_ID" class="bottoml">
                <template>
                  <v-list-item-content>
                    <v-list-item-title v-html="sav.html"></v-list-item-title>
                    <v-list-item-subtitle
                      >{{ sav.html2 }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

        <v-subheader class="sections">Documents</v-subheader>
        <v-list two-line>
          <v-list-item-group v-model="listrdv" active-class="pink--text">
            <template v-for="doc in docs">
              <v-list-item :key="doc.id" class="bottoml">
                <template>
                  <v-list-item-content>
                    <v-list-item-title> {{ doc.html }}</v-list-item-title>
                    <v-list-item-subtitle
                      ><a :href="doc.url" target="_blank">{{ doc.lien }}</a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
  <div>
    <v-subheader class="sections">Photos</v-subheader>
    <v-list two-line>
      <v-list-item-group active-class="pink--text">
        <template v-for="photo in photos">
          <v-list-item :key="photo.id" class="bottoml">
            <v-list-item-avatar>
              <!-- Ajout de l'événement @click pour ouvrir la photo -->
              <v-img
                :src="photo.url"
                max-height="100"
                max-width="100"
                contain
                @click="openPhoto(photo.url)"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>{{ photo.cmt }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>

    <!-- Ajout du v-dialog pour afficher la photo en plein écran -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-img :src="selectedPhoto" max-height="100%" max-width="100%"></v-img>
      </v-card>
    </v-dialog>
  </div>

        <v-btn
          v-if="ClickOK == 1"
          class="editCont"
          color="blue"
          dark
          fixed
          bottom
          right
          fab
          @click="EditContact"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <!--################    MODALE NOTE ################################### -->
    <v-dialog
      v-model="showModalNote"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#FEF3C8">
          <v-btn icon dark @click="showModalNote = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h2>
              {{ raisonModal }} {{ civ }} {{ nom }} {{ nouvnom }}
            </h2></v-toolbar-title
          >
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-textarea
            outlined
            v-model="decnote"
            label="Commentaire"
          ></v-textarea>
          <v-btn color="success" class="mr-4" @click="enregNote">
            Enregistrer
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>

    <!--################    MODALE CONTACT ################################### -->
    <v-dialog
      v-model="showModalCont"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#FEF3C8">
          <v-btn icon dark @click="showModalCont = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h2>
              {{ raisonModal }} {{ civ }} {{ nom }} {{ nouvnom }}
            </h2></v-toolbar-title
          >
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="civ"
            :rules="nameRules"
            label="Civilité"
            required
          ></v-text-field>

          <v-text-field
            v-model="nom"
            :rules="nameRules"
            label="Nom"
            required
          ></v-text-field>

          <v-text-field
            v-model="pren"
            :rules="nameRules"
            label="Prénom"
            required
          ></v-text-field>

          <v-text-field
            v-if="Regles['nouvnom']"
            v-model="nouvnom"
            label="Référence"
          ></v-text-field>

          <v-text-field
            v-model="rue"
            :rules="nameRules"
            label="Rue"
            required
          ></v-text-field>

          <v-text-field
            v-model="CodeP"
            :rules="nameRules"
            label="Code Postal"
            required
          ></v-text-field>

          <v-text-field
            v-model="ville"
            :rules="nameRules"
            label="Ville"
            required
          ></v-text-field>

          <v-text-field
            v-model="mob"
            :rules="nameRules"
            label="mobile"
          ></v-text-field>

          <v-text-field v-model="fixe" label="fixe"></v-text-field>

          <v-text-field
            v-model="mail"
            :rules="emailRules"
            label="E-mail"
          ></v-text-field>

          <v-select
            v-model="orig"
            :items="Origines"
            item-text="Orig_Nom"
            item-value="Orig_ID"
            :rules="[v => !!v || 'L\'origine est requise']"
            label="Source"
            @change="GetOrigMkt"
            required
          ></v-select>

          <v-select
            v-model="cmkt"
            :items="CatMKT"
            item-text="CatM_Nom"
            item-value="CatM_ID"
            label="Sous origine"
          ></v-select>

          <v-select
            v-if="Regles['decoiso']"
            v-model="soucatmkt"
            :items="Soucatmkt"
            item-text="Sc_Nom"
            item-value="Sc_ID"
            label="Sous catégories"
          ></v-select>

          <v-select
            v-model="activite"
            :items="Activites"
            item-text="Act_Nom"
            item-value="Act_ID"
            label="Activité"
          ></v-select>

          <v-select
            v-if="Regles['decoiso']"
            v-model="intext"
            :items="Intexts"
            item-text="Opt_Nom"
            item-value="Opt_Value"
            label="Int / Ext"
          ></v-select>

          <v-select
            v-if="Regles['arcenciel']"
            v-model="CouleurM"
            :items="Couleurs"
            item-text="Typo_Nom"
            item-value="Typo_ID"
            label="Couleur M"
            required
          ></v-select>

          <v-select
            v-if="Regles['arcenciel']"
            v-model="CouleurMme"
            :items="Couleurs"
            item-text="Typo_Nom"
            item-value="Typo_ID"
            label="Couleur Mme"
            required
          ></v-select>

          <v-text-field
            v-if="Regles['detorig']"
            v-model="Cont_CatMKTTXT"
            label="Detail Origine"
          ></v-text-field>

          <v-textarea outlined v-model="cmt" label="Commentaire"></v-textarea>

          <v-btn
            v-show="FormEnr"
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="validateEnr"
          >
            Enregistrer
          </v-btn>

          <v-btn
            v-show="!FormEnr"
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="validateUpd"
          >
            Mettre à jour
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>

    <!-----------------------------------------------   --------->
    <v-btn
      v-if="ClickOK == 1"
      color="pink"
      dark
      fixed
      bottom
      class="addCont"
      right
      fab
      @click="PreAddContact"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-btn color="purple" dark fixed top right fab @click="GetLocation">
      <v-icon>mdi-map-marker-radius</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { minuAPI } from '../services/http-common'
import * as fb from '../firebase'
import Swal from 'sweetalert2'

import { Plugins } from '@capacitor/core'

const { Storage } = Plugins

export default {
  data: () => ({
    etats: [],
    raisonModal: '',
    liste: [],
    search: '',
    chosenOne: [],
    showModalDoss: false,
    showModalCont: false,
    showModalNote: false,
    decnote: '',
    editedNote: 0,
    Origines: [],
    CatMKT: [],
    chosenEtat: 0,

    rdvs: [],
    affaires: [],
    savs: [],
    notes: [],
    docs: [],
    photos: [],
    Activites: [],
    Soucatmkt: [],
    Intexts: [],
    Couleurs: [],

    FormEnr: true,

    civ: '',
    nom: '',
    nouvnom: '',
    pren: '',
    mail: '',
    orig: 0,
    cmkt: 0,
    rue: '',
    ville: '',
    CodeP: '',
    mob: '',
    fixe: '',
    cmt: '',
    etat: '',
    Cont_CatMKTTXT: '',
    activite: 0,
    soucatmkt: 0,
    intext: 0,
    CouleurM: 0,
    CouleurMme: 0,
    ClickOK: 1,
    valid: true,
    Regles: [],
    dialog: false, // Pour gérer l'état du v-dialog
    selectedPhoto: null, // Pour stocker l'URL de la photo sélectionnée

    nameRules: [v => !!v || 'Ce champ est requis'],

    emailRules: [
      v =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'E-mail doit etre valide'
    ],
    select: null,
    checkbox: false
  }),

  watch: {
    search (value) {
      if (value.length > 2) this.getContacts(value)
    },
    showModalDoss: function (newVal, oldVal) {
      if (newVal === false) {
        // La variable showModalDoss est passée à false
        // Vous pouvez modifier d'autres variables ici
        this.id = 0
        console.log('Remise à zero a showModalDoss')
      }
    }
  },

  created () {
    // Vérifier si 'contactData' existe
    const contactData = this.$route.params.contact
    if (contactData) {
      console.log('Contact data:', contactData)
      this.getContacts(contactData)
      console.log(this.liste)
    } else {
      minuAPI
        .post('contactDoss.php', {
          email: fb.auth.currentUser.email,
          mounted: 'ok'
        })
        .then(response => {
          this.liste = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },

  methods: {
    openPhoto (url) {
      this.selectedPhoto = url // Définir la photo sélectionnée
      this.dialog = true // Ouvrir le dialog
    },
    handleAppelClick (tel) {
      // Récupération de l'ID de l'élément cliqué
      const elementId = this.chosenOne.Cont_ID
      const dataNum = tel

      console.log('Div appel clicked with ID:', elementId)
      // Ajoutez votre logique ici en utilisant elementId
      // Exemple : this.someFunctionUsingId(elementId);

      minuAPI
        .post('addAppel.php', {
          email: fb.auth.currentUser.email,
          dataNum: dataNum,
          id: elementId
        })
        .then(response => {
          Swal.fire({
            title: 'Appel',
            text: 'Une note appel est enregistrée',
            icon: 'success',
            button: 'ok'
          })
          window.location.href = `tel:${tel}`
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    UpdEtat () {
      minuAPI
        .post('etats.php', {
          email: fb.auth.currentUser.email,
          id: this.chosenOne.Cont_ID,
          etat: this.chosenEtat,
          upd: 'ok'
        })
        .then(response => {
          this.chosenOne.Cont_Etat = this.chosenEtat
          Swal.fire({
            title: 'MIS A JOUR',
            text: '',
            icon: 'success',
            timer: 1000,
            timerProgressBar: true
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    ajoutNote () {
      minuAPI
        .post('updnote.php', {
          email: fb.auth.currentUser.email,
          id: this.chosenOne.Cont_ID,
          add: 'ok'
        })
        .then(response => {
          Swal.fire({
            title: 'AJOUT FAIT',
            text: '',
            icon: 'success',
            timer: 1000,
            timerProgressBar: true
          })

          minuAPI
            .post('notes.php', {
              CL: this.id,
              email: fb.auth.currentUser.email
            })
            .then(response => {
              this.notes = response.data
              // console.log(response.data) // properties
            })
            .catch(e => {
              this.errors.push(e)
            })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    EditNote (id, desc) {
      console.log('EDIT note')
      this.showModalNote = true
      this.decnote = desc
      console.log(id)
      this.editedNote = id
      this.raisonModal = ''
    },

    enregNote () {
      minuAPI
        .post('updnote.php', {
          email: fb.auth.currentUser.email,
          id: this.chosenOne.Cont_ID,
          desc: this.decnote,
          noteid: this.editedNote
        })
        .then(response => {
          Swal.fire({
            title: 'MIS A JOUR',
            text: '',
            icon: 'success',
            timer: 1000,
            timerProgressBar: true
          })

          minuAPI
            .post('notes.php', {
              CL: this.id,
              email: fb.auth.currentUser.email
            })
            .then(response => {
              this.notes = response.data
              // console.log(response.data) // properties
            })
            .catch(e => {
              this.errors.push(e)
            })
        })
        .catch(e => {
          this.errors.push(e)
        })
      this.showModalNote = false
      this.decnote = ''
      this.editedNote = 0
    },

    EditContact () {
      console.log('EDIT contact')
      this.showModalCont = true
      this.raisonModal = 'Édition de '
      this.GetOrig()
      this.FormEnr = false

      this.civ = this.chosenOne.Cont_Civ
      this.nom = this.chosenOne.Cont_Nom
      this.nouvnom = this.chosenOne.Cont_Nouvnom
      this.pren = this.chosenOne.Cont_Pren
      this.mail = this.chosenOne.Cont_Email
      this.orig = this.chosenOne.Cont_CatMKT
      this.cmkt = this.chosenOne.Cont_Orig
      this.soucatmkt = this.chosenOne.Cont_SousCatMKT
      this.rue = this.chosenOne.Cont_Rue
      this.ville = this.chosenOne.Cont_Ville
      this.CodeP = this.chosenOne.Cont_Postal
      this.mob = this.chosenOne.Cont_TelMob
      this.fixe = this.chosenOne.Cont_TelFix
      this.cmt = this.chosenOne.Cont_Comment
      this.etat = this.chosenOne.Cont_Etat
      this.activite = this.chosenOne.Cont_Activite
      this.intext = this.chosenOne.Cont_IntExt
      this.CouleurM = this.chosenOne.Cont_Typo1
      this.CouleurMme = this.chosenOne.Cont_Typo2
      this.Cont_CatMKTTXT = this.chosenOne.Cont_CatMKTTXT
    },

    UpdContact () {
      console.log('UPDATE contact')

      this.chosenOne.Cont_Civ = this.civ
      this.chosenOne.Cont_Nom = this.nom
      this.chosenOne.Cont_Nouvnom = this.nouvnom
      this.chosenOne.Cont_Pren = this.pren
      this.chosenOne.Cont_Email = this.mail
      this.chosenOne.Cont_Orig = this.orig
      this.chosenOne.Cont_CatMKT = this.cmkt
      this.chosenOne.Cont_SousCatMKT = this.soucatmkt
      this.chosenOne.Cont_Rue = this.rue
      this.chosenOne.Cont_Ville = this.ville
      this.chosenOne.Cont_Postal = this.CodeP
      this.chosenOne.Cont_TelMob = this.mob
      this.chosenOne.Cont_TelFix = this.fixe
      this.chosenOne.Cont_Comment = this.cmt
      this.chosenOne.Cont_Activite = this.activite
      this.chosenOne.Cont_IntExt = this.intext
      this.chosenOne.Cont_Typo1 = this.CouleurM
      this.chosenOne.Cont_Typo2 = this.CouleurMme
      this.chosenOne.Cont_CatMKTTXT = this.Cont_CatMKTTXT

      minuAPI
        .post('addContact.php', {
          email: fb.auth.currentUser.email,
          form: 'upd',
          fields: {
            civ: this.civ,
            nom: this.nom,
            nouvnom: this.nouvnom,
            pren: this.pren,
            mail: this.mail,
            orig: this.orig,
            cmkt: this.cmkt,
            rue: this.rue,
            ville: this.ville,
            CodeP: this.CodeP,
            soucatmkt: this.soucatmkt,
            mob: this.mob,
            fixe: this.fixe,
            cmt: this.cmt,
            activite: this.activite,
            intext: this.intext,
            CouleurM: this.CouleurM,
            CouleurMme: this.CouleurMme,
            Cont_CatMKTTXT: this.Cont_CatMKTTXT,
            id: this.id
          }
        })
        .then(response => {
          console.log(response.data) // properties
          this.getContacts(response.data.updID)
          this.showModalCont = false
          Swal.fire({
            title: 'MIS A JOUR',
            text: '',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    GetLocation () {
      console.log('Get location')
      // do we support geolocation
      if (!('geolocation' in navigator)) {
        console.log('Geolocation is not available.')
        return
      }

      navigator.geolocation.getCurrentPosition(
        pos => {
          console.log(pos)

          // console.log(this.events)
          minuAPI
            .post('contactLocate.php', {
              email: fb.auth.currentUser.email,
              Lat: pos.coords.latitude,
              Lon: pos.coords.longitude
            })
            .then(response => {
              this.liste = response.data

              // console.log(response.data) // properties
            })
            .catch(e => {
              this.errors.push(e)
            })
        },
        err => {
          console.log(err.message)
        }
      )
    },

    validateEnr () {
      if (this.$refs.form.validate()) this.AddContact()
    },

    validateUpd () {
      if (this.$refs.form.validate()) this.UpdContact()
    },

    SelectedCont (value) {
      this.GetEtats()
      this.chosenOne = value
      this.ClickOK = value.clikok
      this.showModalDoss = true
      this.id = this.chosenOne.Cont_ID
      this.chosenEtat = this.chosenOne.Cont_Etat
      console.log(
        'Selected Cont : recherche : ' +
          value.Cont_ID +
          ' Etat : ' +
          this.chosenOne.Cont_Etat
      )

      console.log('ouvre la modal dossier')
      Storage.set({
        key: 'contact',
        value: JSON.stringify({
          nom: this.chosenOne.Cont_Nom,
          id: value.Cont_ID,
          ID: value.ID
        })
      })

      minuAPI
        .post('events2.php', {
          CL: value.Cont_ID,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.rdvs = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })

      minuAPI
        .post('affaires.php', {
          CL: value.Cont_ID,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.affaires = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })

      minuAPI
        .post('savs.php', {
          CL: value.Cont_ID,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.savs = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })

      minuAPI
        .post('notes.php', {
          CL: value.Cont_ID,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.notes = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })

      minuAPI
        .post('docs.php', {
          CL: value.Cont_ID,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.docs = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })

      minuAPI
        .post('photos.php', {
          CL: value.Cont_ID,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.photos = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    GetOrig () {
      console.log('Getorig')
      minuAPI
        .post('addContact.php', {
          email: fb.auth.currentUser.email,
          form: 'edit',
          id: this.id
        })
        .then(response => {
          this.Regles = response.data.Json
          this.Origines = response.data.Origine
          this.Activites = response.data.Activites
          this.Soucatmkt = response.data.Soucatmkt
          this.Intexts = response.data.Intexts
          this.Couleurs = response.data.Couleurs
          this.orig = response.data.Orig
          this.cmkt = response.data.mkt
          this.activite = response.data.activite
          this.intext = response.data.intext
          this.GetOrigMkt()
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    GetOrigMkt () {
      console.log('GetMKT')
      minuAPI
        .post('getmkt.php', {
          email: fb.auth.currentUser.email,
          form: 'edit',
          orig: this.orig
        })
        .then(response => {
          this.CatMKT = response.data.CatMKT
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    GetEtats () {
      console.log('Get Etat')
      minuAPI
        .post('etats.php', {
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.etats = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    PreAddContact () {
      this.FormEnr = true
      console.log('PreAddContact')
      this.showModalCont = true
      this.raisonModal = 'Ajout de '
      this.GetOrig()

      this.civ = ''
      this.nom = ''
      this.nouvnom = ''
      this.pren = ''
      this.mail = ''
      this.orig = ''
      this.cmkt = ''
      this.rue = ''
      this.ville = ''
      this.CodeP = ''
      this.mob = ''
      this.fixe = ''
      this.cmt = ''
      this.activite = ''
      this.intext = ''
      this.Cont_CatMKTTXT = ''
    },

    AddContact () {
      console.log('AddContact')
      this.showModalCont = false

      minuAPI
        .post('addContact.php', {
          email: fb.auth.currentUser.email,
          form: 'add',
          fields: {
            civ: this.civ,
            nom: this.nom,
            nouvnom: this.nouvnom,
            pren: this.pren,
            mail: this.mail,
            orig: this.orig,
            cmkt: this.cmkt,
            rue: this.rue,
            ville: this.ville,
            CodeP: this.CodeP,
            mob: this.mob,
            fixe: this.fixe,
            cmt: this.cmt,
            activite: this.activite,
            intext: this.intext,
            CouleurM: this.CouleurM,
            CouleurMme: this.CouleurMme,
            Cont_CatMKTTXT: this.Cont_CatMKTTXT
          }
        })
        .then(response => {
          console.log(response.data) // properties
          this.getContacts(response.data.LastID)
          Swal.fire({
            title: 'ENREGISTRÉ',
            text: '',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    getContacts (value) {
      console.log('getContacts')
      minuAPI
        .post('contactDoss.php', {
          email: fb.auth.currentUser.email,
          search: value
        })
        .then(response => {
          this.liste = response.data
          console.log('liste : ' + this.liste.length)
          if (this.liste.length == 1) this.SelectedCont(this.liste[0])
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  mounted () {}
}
</script>

<style scoped>
.bottoml {
  border-bottom: 1px solid #bd595d;
}

.theme--dark.v-btn.v-btn--icon,
.theme--light.v-card {
  color: #bd595d;
}

.theme--light.v-sheet {
  background-color: #bdddbf;
}

.theme--dark.v-sheet {
  color: #bd595d;
}

.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #bd595d;
}

.calend {
  background-color: #e63295;
}

.v-toolbar .v-input {
  margin-top: 25px;
}
.liste .v-list-item__title {
  text-align: left;
}

.addCont {
  margin-bottom: 50px;
}

.editCont {
  margin-bottom: 50px;
}

.v-form {
  padding: 20px;
}

.sections {
  font-size: 20px;
  background-color: #ffffff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Contacts.vue